import { LOCATIONS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/locations_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'locationsIndex',
	'locationsAnalyticsDropdown',
	'rankingPageLocations',
	'privateNetworkLocationsPageFilters',
	'supplierPrivateNetworksAdvancedFilters',
	'METER_FORM_LOCATIONS_AUTOCOMPLETE',
	'ASSET_FORM_LOCATIONS_AUTOCOMPLETE',
	'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE',
	'SUPPLIER_WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE',
	'SUPPLIER_PRIVATE_NETWORK_FORM_LOCATIONS_AUTOCOMPLETE',
	'ENTITY_REQUEST_SUPPLIER_LOCATIONS_AUTOCOMPLETE',
	'SUPPLIER_PRIVATE_NETWORK_COPY_TO_LOCATIONS_AUTOCOMPLETE',
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_LOCATIONS_AUTOCOMPLETE',
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_ADD_LOCATIONS_AUTOCOMPLETE',
	'BUDGETS_FORM_LOCATIONS_AUTOCOMPLETE',
	'PROJECT_INVOICE_LOCATIONS_AUTOCOMPLETE',
	'COMPLIANCE_REQUEST_FORM_LOCATIONS_AUTOCOMPLETE',
	'SUPPLIER_CLIENT_LOCATIONS',
	'SITE_SURVEY_FORM_LOCATIONS_AUTOCOMPLETE',
	'SITE_SURVEY_FORM_EXISTING_LOCATIONS_AUTOCOMPLETE',
	'workOrdersAdvancedFilters',
	'invoicesAdvancedFilters',
	'quotesAdvancedFilters',
	'assetsAdvancedFilters',
	'siteSurveysAdvancedFilters',
	'adminStoreAssociateIndex',
	'adminFieldTechsIndex',
	'metersAdvancedFilters',
	'techAnalyticsAdvancedFilters',
	'buyerUsersLocations',
	'plannedMaintenanceAdvancedFilters',
	'purchaseRequestsAdvancedFilters',
	'prLineItemsAdvancedFilters',
	'purchaseOrdersAdvancedFilters',
	'poLineItemsAdvancedFilters',
	'addPartsDropdown',
	'epslAdvancedFilters',
	'requestedPartsAdvancedFilters',
	'troubleshootingFormIndex',
	'assetTransferTargetCollection',
	'walkthroughAdvancedFilters',
	'supplierPrivateNetworkAdvancedFilters',
	'rfpAdvancedFilters',
	'biddersAdvancedFilters',
	'troubleshooting_advanced_filters',
	'workOrdersCalendarIndex',
	'ASSET_CYCLE_RUN_FORM_LOCATIONS_AUTOCOMPLETE',
	'scheduledTransferDropdown',
	'walkthroughLocationsDropdown',
	'approvalRulesLocations',
	'wrenchModeLogsLocationFilter',
	'routingPageLocationFilter',
	'fieldTechAccessibleLocations',
	'complianceRequestsLocationFilter',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
